import React, { useCallback, useEffect, useState } from "react";
import { Tables } from "../../components/Elements/Tables/Tables";
import { ReactComponent as BackIcon } from "../../assets/svgs/back-square.svg";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
// import toast from "react-hot-toast";
import AddModifyButton from "./components/AddModifyButton";
import QuestionDialog from "../StandardForms/DialogBoxes/QuestionDialog";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";
const SubSectionss = ({ formId, sectionId, onSubSectionSelect, approved }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
 const [popup, setPopup] = useState({
    open: false,
    title: "",
    message: "",
  });
//Add modify button click handler
  const handleAddModifyClick = () => {
    if (approved === true) {
      setPopup({
        open: true,
        title: "Form Already Approved",
        message:
          "This Standard Form has already been approved and is currently locked for editing. To make modifications, the manager must unlock it or change its status to Draft first.",
      });
      return;
    }
    setOpenCreateDialog(true);
  };

//Popup auto close 
  useEffect(() => {
      if (popup.open) {
        const timer = setTimeout(() => {
          setPopup((prev) => ({
            ...prev,
            open: false,
          }));
        }, 5000);
  
        return () => clearTimeout(timer);
      }
    }, [popup.open]);



  const fetchSubSections = useCallback(async () => {
    if (!formId || !sectionId) return;
    try {
      setLoading(true);
      const response = await getApi({
        apiUrl: API_URLS.GET_STANDARD_SUBSECTION_BY_ID(formId, sectionId)
      });

      if (response.success) {
        const data = Array.isArray(response?.data?.subsections)
          ? response.data.subsections
          : [];

        setTotalRecords(response?.data?.totalSubsections || 0);

        const formattedData = data.map((item, index) => ({
          key: item.subsectionId,
          serial: index + 1,
          sub_section: item.name || "-",
          totalQuestion: item.totalQuestions || 0,
          action: (
            <EyeOutlined
              style={{ fontSize: "18px", cursor: "pointer" }}
              onClick={() => {
                onSubSectionSelect({
                  formId,
                  sectionId,
                  subSectionName: item.name,
                  subSectionId: item.subsectionId

                  // totalQuestions
                });
              }}
            />
          )
        }));

        setTableData(formattedData);
      } else {
        setTableData([]);
      }
    } catch (err) {
      console.error("Error fetching subsections", err);
      // toast.error("Failed to fetch subsections");
      setTableData([]);
    } finally {
      setLoading(false);
    }
  }, [formId, sectionId, navigate]);

  useEffect(() => {
    fetchSubSections();
  }, [fetchSubSections]);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Sub-Section", key: "sub_section" },
    { label: "Total Questions", key: "totalQuestion" },
    { label: "Action", key: "action" }
  ];

  const handleSearch = (value) => {
    setSearchTerm(value.toLowerCase());
    if (!value) {
      fetchSubSections();
    } else {
      const filtered = tableData.filter((item) =>
        item.sub_section.toLowerCase().includes(value.toLowerCase())
      );
      setTableData(filtered);
    }
  };

  return (
    <div style={{ backgroundColor: "#fff" }} className="h-screen">
      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          paddingTop: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F"
        }}
      >
        {" "}
        <div className="flex justify-between mx-8">
          <div className="flex gap-4 pl-3">
            <p className="px-8  h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
              TOTAL SUB SECTION {totalRecords}
            </p>

            <SearchBar width="300px" onSearch={handleSearch} />
          </div>
          <div className="flex gap-5">
             <AddModifyButton onClick={handleAddModifyClick} />
          </div>
        </div>
        <div className="px-2">
          <Tables
            data={tableData}
            headers={headers}
            loading={loading}
            current={1}
            onChange={() => {}}
            total={tableData.length}
            pageSize={tableData.length}
            pagination={false}
          />
        </div>
      </div>
      {openCreateDialog && (
        <QuestionDialog
          onOpen={openCreateDialog}
          formId={formId}
          onClose={() => setOpenCreateDialog(false)}
        />
      )}



          {popup.open && (
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20">
                <PopupCard
                  title={popup.title}
                  type="error"
                  message={popup.message}
                  onOpen={popup.open}
                  onClose={() => setPopup((prev) => ({ ...prev, open: false }))}
                />
              </div>
            )}
    </div>
  );
};

export default SubSectionss;
